/* GLG MOQ (Bernie v69): snap typed quantities to min + carton multiples.
   The theme bundle's +/- buttons use native stepUp/stepDown (honour min/step),
   but typed values are never validated (forms are novalidate and ProductForm
   preventDefaults before native validation runs). Capture-phase listeners run
   before the bundle's debounced cart handlers read input.value. */
(function () {
  function snap(input) {
    var min = parseInt(input.min, 10) || 1;
    var step = parseInt(input.step, 10) || 1;
    var v = parseInt(input.value, 10);
    if (isNaN(v) || v < min) v = min;
    else v = min + Math.round((v - min) / step) * step;
    if (String(v) !== input.value) input.value = v;
  }
  document.addEventListener(
    'change',
    function (e) {
      var t = e.target;
      if (t && t.matches && t.matches('[data-quantity-input]')) snap(t);
    },
    true
  );
  document.addEventListener(
    'submit',
    function (e) {
      var f = e.target;
      if (!f || !f.matches || !f.matches('form[data-type="add-to-cart-form"]')) return;
      var q =
        (f.id && document.querySelector('[data-quantity-input][form="' + f.id + '"]')) ||
        f.querySelector('[data-quantity-input]');
      if (q) snap(q);
    },
    true
  );
})();
